import {
  SAMPLE_RULE_FIELD_DEFINITIONS,
  type SampleRuleCondition,
  type SampleRuleFieldId,
  type SampleRuleOperator,
} from "@unbox/api";

export const FIELD_OPTIONS = (Object.keys(SAMPLE_RULE_FIELD_DEFINITIONS) as SampleRuleFieldId[]).map((id) => ({
  id,
  label: SAMPLE_RULE_FIELD_DEFINITIONS[id].label,
  supportingText: SAMPLE_RULE_FIELD_DEFINITIONS[id].tooltip,
}));

export const NUMERIC_OPERATOR_OPTIONS: { id: SampleRuleOperator; label: string }[] = [
  { id: "eq", label: "is" },
  { id: "gt", label: "greater than" },
  { id: "gte", label: "at least" },
  { id: "lt", label: "less than" },
  { id: "lte", label: "at most" },
  { id: "between", label: "between" },
];

export const TAG_OPERATOR_OPTIONS: { id: SampleRuleOperator; label: string }[] = [
  { id: "is", label: "is" },
  { id: "is_not", label: "is not" },
];

export function fieldKind(field: SampleRuleFieldId): "numeric" | "tag" {
  return SAMPLE_RULE_FIELD_DEFINITIONS[field]?.kind ?? "numeric";
}

export function defaultConditionForField(field: SampleRuleFieldId): SampleRuleCondition {
  return (
    fieldKind(field) === "tag" ? { field, operator: "is", value: "" } : { field, operator: "gt", value: 0 }
  ) as SampleRuleCondition;
}

export function makeDefaultCondition(): SampleRuleCondition {
  return defaultConditionForField("gmvAmount");
}

export function isConditionComplete(condition: SampleRuleCondition): boolean {
  if (fieldKind(condition.field) === "tag") {
    return typeof condition.value === "string" && condition.value.length > 0;
  }
  if (condition.operator === "between") {
    return Array.isArray(condition.value) && condition.value.length === 2 && condition.value.every(Number.isFinite);
  }
  return typeof condition.value === "number" && Number.isFinite(condition.value);
}
